import { useIntl } from '@/intl'
import { Banner, Typography } from '@sunwebgroup/ui-components'

export function NoReviewsMessage() {
  const intl = useIntl()
  return (
    <Banner $type="info">
      <Typography $variant="body-md">{intl.formatMessage({ id: 'reviews_no_reviews_teaser' })}</Typography>
    </Banner>
  )
}
